import React, { useEffect, useState } from 'react';
import api from '../../api/api';
import { Card } from '../../components/ui';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';

export default function StockHome() {
  const { stockEnabled: tenantStockEnabled, isCabinet } = useAuth();
  const { workspaceStockEnabled } = useWorkspace();
  const stockEnabled = isCabinet ? workspaceStockEnabled : tenantStockEnabled;
  const [summary, setSummary] = useState(null);
  const [recentMovements, setRecentMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!stockEnabled) return;
    const fetchSummary = async () => {
      try {
        const res = await api.get('/stock/summary');
        if (res.data.ok) {
          setSummary(res.data.summary);
          setRecentMovements(res.data.recentMovements || []);
        }
      } catch (err) {
        console.error('Erreur chargement résumé stock:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, [stockEnabled]);

  if (!stockEnabled) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-3xl mx-auto">
          <Card>
            <h1 className="text-xl font-bold text-gray-900 mb-2">Stock</h1>
            <p className="text-gray-600">Module désactivé pour ce cabinet.</p>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Tableau de bord Stock</h1>

        {loading ? (
          <p className="text-gray-500">Chargement...</p>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
              <Card className="p-4">
                <p className="text-sm text-gray-500 mb-1">Articles actifs</p>
                <p className="text-3xl font-bold text-gray-900">{summary?.totalItems || 0}</p>
              </Card>
              <Card className="p-4">
                <p className="text-sm text-gray-500 mb-1">Stock bas</p>
                <p className="text-3xl font-bold text-yellow-600">{summary?.lowStockItems || 0}</p>
              </Card>
              <Card className="p-4">
                <p className="text-sm text-gray-500 mb-1">En rupture</p>
                <p className="text-3xl font-bold text-red-600">{summary?.outOfStockItems || 0}</p>
              </Card>
              <Card className="p-4">
                <p className="text-sm text-gray-500 mb-1">Valeur du stock</p>
                <p className="text-3xl font-bold text-green-600">
                  {(summary?.totalValue || 0).toLocaleString('fr-TN', { style: 'currency', currency: 'TND' })}
                </p>
              </Card>
            </div>

            <Card>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Derniers mouvements</h2>
              {recentMovements.length === 0 ? (
                <p className="text-gray-500">Aucun mouvement récent.</p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm">
                    <thead>
                      <tr className="border-b">
                        <th className="text-left py-2 px-3">Article</th>
                        <th className="text-left py-2 px-3">Type</th>
                        <th className="text-right py-2 px-3">Qté</th>
                        <th className="text-right py-2 px-3">Date</th>
                        <th className="text-left py-2 px-3">Référence</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentMovements.map((m) => (
                        <tr key={m._id} className="border-b hover:bg-gray-50">
                          <td className="py-2 px-3">{m.itemId?.name || 'N/A'}</td>
                          <td className="py-2 px-3">
                            <span className={`inline-flex px-2 py-0.5 rounded text-xs font-bold ${m.type === 'in' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                              {m.type === 'in' ? 'Entrée' : 'Sortie'}
                            </span>
                          </td>
                          <td className="py-2 px-3 text-right">{m.quantity}</td>
                          <td className="py-2 px-3 text-right">{new Date(m.movementDate).toLocaleDateString('fr-TN')}</td>
                          <td className="py-2 px-3">{m.reference || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Card>
          </>
        )}
      </div>
    </div>
  );
}
